'use strict';

var ROMAnalysisFilterByPaxGridBrush = function ROMAnalysisFilterByPaxGridBrush(DataFilter) {
  function ROMAnalysisFilterByPaxGridBrush() {
    DataFilter.call(this, ['rom-analysis-loco-mode', 'rom-analysis-demand-pax-mode', 'rom-analysis-flattened-services-mode'], 'pax-grid', 2);
  }
  ROMAnalysisFilterByPaxGridBrush.prototype = Object.create(DataFilter.prototype);
  ROMAnalysisFilterByPaxGridBrush.prototype.filter = function (data, range) {
    range = range[0];
    var key = Object.getOwnPropertyNames(range)[0];
    if (range[key].length) {
      return DataFilter.prototype.filter(data, range[key], key);
    } else {
      return data;
    }
  };
  return ROMAnalysisFilterByPaxGridBrush;
};
ROMAnalysisFilterByPaxGridBrush.$inject = ['DataFilterFactory'];
module.exports = ROMAnalysisFilterByPaxGridBrush;